import { render, staticRenderFns } from "./Frequencia.vue?vue&type=template&id=930720e2&"
import script from "./Frequencia.vue?vue&type=script&lang=js&"
export * from "./Frequencia.vue?vue&type=script&lang=js&"
import style0 from "./Frequencia.vue?vue&type=style&index=0&id=930720e2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports